import InvoicePage from './InvoicePage';

export default InvoicePage;
